/**
 * Single source of truth for GP Capital legal entity + brand info.
 * Reference anywhere legal/entity copy appears so it stays consistent.
 *
 * Public-facing policy: ONLY `info@gp-cap.com` actually exists as a
 * receiving inbox. Every public CTA routes there with a subject prefilled
 * so inbound mail can still be segmented downstream.
 */
const PRIMARY_INBOX = 'info@gp-cap.com';

export const ENTITY = {
  legalName: 'GP CAP Pty Ltd',
  brand: 'GP Capital',
  acn: '665 155 608',
  abn: '90 665 155 608',
  legalWithAcn: 'GP CAP Pty Ltd (ACN 665 155 608)',
  legalWithAbn: 'GP CAP Pty Ltd (ABN 90 665 155 608)',
  legalFull: 'GP CAP Pty Ltd (ACN 665 155 608, ABN 90 665 155 608)',
  // All public inboxes route to the single existing mailbox.
  contact: {
    general: PRIMARY_INBOX,
    deals: PRIMARY_INBOX,
    lenders: PRIMARY_INBOX,
    compliance: PRIMARY_INBOX,
    giorgio: 'giorgiop@gp-cap.com',
  },
  // Subject-line segmentation for inbound triage.
  mailSubjects: {
    deals: 'Deal Submission — GP Capital',
    lenders: 'Lender / Family Office Access — GP Capital',
    compliance: 'Compliance Enquiry — GP Capital',
    general: 'General Enquiry — GP Capital',
    giorgio: 'For Giorgio Primiceri — GP Capital',
  },
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=100092571877852',
    linkedin: 'https://www.linkedin.com/company/gp-cap/',
    giorgioLinkedIn: 'https://www.linkedin.com/in/giorgio-primiceri-642162229',
  },
};

export default ENTITY;
